import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CurrentUserService } from 'admin/core/auth/current-user.service';

export const authGuard: CanActivateFn = () => {
  if (inject(CurrentUserService).user() !== null) {
    return true;
  }

  return inject(Router).createUrlTree(['/auth/login']);
};
